import { Component } from '@angular/core';
import { LoaderComponent } from '../Component/Loader/loader/loader.component';
import { CommonModule } from '@angular/common';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule } from '@angular/forms';
import { ComboService } from '../Model/Combo/combo.service';
import { CommonService } from '../Model/Common/common.service';
import { ToastService, toastTypeEnum } from '../Util/Toast/toast.service';
import { SessionService } from '../Util/Session/session.service';
import { NgbDatepickerModule } from '@ng-bootstrap/ng-bootstrap';
import { ReportsService } from '../Model/Reports/reports.service';
import { DownloadSampleService } from '../Model/DownloadSample/download-sample.service';
import { CustomDateParserFormatter } from '../Util/DateFormat/date-format.service';

@Component({
  selector: 'app-rate-contract-report',
  standalone: true,
  imports: [LoaderComponent, CommonModule, NgSelectModule, FormsModule, NgbDatepickerModule],
  templateUrl: './rate-contract-report.component.html',
  styleUrl: './rate-contract-report.component.scss'
})
export class RateContractReportComponent {

  isDisabled: boolean = false;
  Branchs: any[] = [];
  Clients: any[] = [];
  Sites: any[] = [];
  Types = [{label: 'Salary', value: 'Salary'}, {label: 'Billing', value: 'Billing'}]

  constructor(
    private comboload: ComboService,
    public common: CommonService,
    private toast: ToastService,
    private session: SessionService,
    private report: ReportsService,
    private download: DownloadSampleService,
    private dateFormat: CustomDateParserFormatter,
  ) {
    // this.common.getPageRights();
  }

  ngOnInit(){
    this.ComboLoad('Branch');
  }

  data = {
    BranchId: null,
    ClientId: null,
    SiteId: null,
    MonthYear: null as any,
    Status: 'All',
    Type: 'Billing'
  }

  ComboLoad(Combotype: String) {
    this.isDisabled = true;

    if (Combotype == 'Client') {
      this.Clients = [];
      this.data.ClientId = null;
      this.Sites = [];
      this.data.SiteId = null;
    }
    else if (Combotype == 'Site') {
      this.Sites = [];
      this.data.SiteId = null;
    }

    this.comboload.ComboLoad({
      'Combotype': Combotype,
      'BranchId': (Combotype == 'Client' || Combotype == 'Site' || Combotype == 'Designation' || Combotype == 'Duty') ? this.data.BranchId : 0,
      'ClientId': ((Combotype == 'Client') || Combotype == 'Site' || Combotype == 'Designation' || Combotype == 'Duty') ? this.data.ClientId : 0,
      'SiteId': ((Combotype == 'Site') || Combotype == 'Designation' || Combotype == 'Duty') ? this.data.SiteId : 0,
      'DesignationId': 0,
      'DutyId': 0,
      'EmpType': 'Front',
      'EmpMasterID': this.session.GetUserDetails().UserId
    }).subscribe({
      next: (response) => {
        if (Combotype == 'Branch') {
          if (response.ComboLoad) {
            this.Branchs = response.ComboLoad;
          }
        } else if (Combotype == 'Client') {
          if (response.ComboLoad) {
            this.Clients = response.ComboLoad;
          }
        } else if (Combotype == 'Site') {
          if (response.ComboLoad) {
            this.Sites = response.ComboLoad;
          }
        }
        this.isDisabled = false;
      },
      complete: () => {
      },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  ContractRateReport() {
    this.isDisabled = true;
    this.report.RateContractReport({
      SelectType: this.data.Type,
      BranchID: this.data.BranchId == null ? 0 : this.data.BranchId,
      ClientGroupID: this.data.ClientId == null ? 0 : this.data.ClientId,
      SiteMasterIDs: this.data.SiteId == null ? '0' : this.data.SiteId,
      MonthYear: this.dateFormat.fullmonth[this.data.MonthYear.month - 1] + ' ' + this.data.MonthYear.year,
      Flag: this.data.Status,
    }).subscribe({
      next: (response) => {
        if(response.Table){
          if(response.Table.length > 0){
            this.download.exportToExcelWithProgress(response.Table, 'Rate Contract report');
          }
        }else{
          this.toast.show({message: 'No Data Found', type: toastTypeEnum.warning});
        }
        this.isDisabled = false;
      },
      complete: () => {
      },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  onNavigate(event: any) {
    this.data.MonthYear = {
      "year": event.next.year,
      "month": event.next.month,
      "day": 1
    }
  }

}
